var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 201,
    viewBox: "0 0 264 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2071 183.711C-20.4553 151.513 4.46256 80.6024 45.5204 58.8854C60.9053 50.7651 78.8386 47.6492 96.1112 49.9154C111.685 51.9926 131.128 57.2802 147.08 51.2373C159.161 46.6106 164.73 35.1856 171.054 24.7992C188.609 -4.09387 232.876 -9.47591 254.868 17.9064C262.985 28.0095 266.289 42.0784 262.325 54.4476C252.981 83.1518 221.644 70.877 203.9 86.2677C196.821 92.4051 194.933 104.68 190.78 112.895C186.533 121.298 181.342 129.324 175.773 136.972C164.069 153.118 149.817 167.848 133.394 179.273C100.642 202.123 59.6783 208.922 25.0387 185.788C24.0948 185.127 23.1509 184.466 22.2071 183.711Z",
    fill: "url(#paint0_radial_105_551)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_105_551",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.017 15.9535) rotate(-122.472) scale(310.805 522.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBack);
export default __webpack_public_path__ + "static/media/home-back.96d594cdddea2c6b8a4c10883ebf2048.svg";
export { ForwardRef as ReactComponent };